export const uiDomainInitial = {
  subdomain_prefix: '',
  domain_name: '',
  status: '',
}

export const uiCertificateInitial = {
  certificate: '',
  private_key: '',
  full_chain: '',
  expire_date: null,
  domain: null,
}